import React, { useState } from 'react';
import { Tag, Button, Popover } from 'antd';

const STATUS_OPTIONS = {
  withoutFiles: [
    { value: 'missing', label: 'MANCANTE', color: 'red' },
    { value: 'non_applicabile', label: 'NON APPLICABILE', color: 'default' },
  ],
  withFiles: [
    { value: 'da_controllare', label: 'DA CONTROLLARE', color: 'orange' },
    { value: 'idoneo', label: 'IDONEO', color: 'green' },
    { value: 'non_idoneo', label: 'NON IDONEO', color: 'red' },
  ],
};

/**
 * StatusDropdown Component
 * Renderizza un dropdown di stato come Popover con Tag cliccabile
 * 
 * @param {string} status - Lo stato attuale del documento
 * @param {function} onChange - Callback quando lo stato cambia
 * @param {boolean} hasFiles - Se il documento ha file (determina quali stati sono disponibili)
 * @param {object} record - Record completo (opzionale, per informazioni aggiuntive)
 * @param {string} placement - Posizione del popover (default: 'bottomLeft')
 */
function StatusDropdown({ 
  status, 
  onChange, 
  hasFiles = false,
  record = null,
  placement = 'bottomLeft'
}) {
  const [open, setOpen] = useState(false);
  const statusOptions = hasFiles ? STATUS_OPTIONS.withFiles : STATUS_OPTIONS.withoutFiles;
  const currentOption = statusOptions.find(opt => opt.value === status);
  
  const content = (
    <div style={{ display: 'flex', gap: 8, flexDirection: 'column' }}>
      {statusOptions.map(opt => (
        <Button
          key={opt.value}
          size="small"
          type={opt.value === status ? 'primary' : 'default'}
          onClick={(e) => {
            e.stopPropagation();
            onChange(opt.value);
            setOpen(false);
          }}
          style={{ width: '100%', textAlign: 'left' }}
        >
          <Tag color={opt.color} style={{ margin: 0 }}>
            {opt.label}
          </Tag>
        </Button>
      ))}
    </div>
  );
  
  return (
    <Popover
      content={content}
      trigger="click"
      placement={placement}
      open={open}
      onOpenChange={(visible) => setOpen(visible)}
    >
      <Tag 
        color={currentOption?.color} 
        style={{ cursor: 'pointer' }}
        onClick={(e) => e.stopPropagation()}
      >
        {currentOption?.label}
      </Tag>
    </Popover>
  );
}

export default StatusDropdown;
